import { Injectable } from '@angular/core';
import { HttpServiceBase } from '../http/httpServiceBase';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class MainHttpService extends HttpServiceBase {

    constructor(protected http: HttpClient) {
        super('main');
    }
}
